import { IAppState } from '@state/types';

export const getDSConfig = (state: IAppState): any | undefined => state.dsConfig.dsconfig;